import { create } from "zustand";
import { persist } from "zustand/middleware";

interface IPartnerStore {
  sessionExpiredRedirectUrl: string | null;
  partnerName: string | null;
  supportEmail: string | null;
  supportWhatsappNumber: string | null;
  setPartnerInfo: (info: {
    sessionExpiredRedirectUrl?: string;
    name?: string;
    supportEmail?: string;
    supportWhatsappNumber?: string;
  }) => void;
  clearPartnerInfo: () => void;
}

/**
 * Persists partner info needed even after the session expires (kept separate
 * from useSessionStore so it survives a session error state).
 */
export const usePartnerStore = create<IPartnerStore>()(
  persist(
    (set) => ({
      sessionExpiredRedirectUrl: null,
      partnerName: null,
      supportEmail: null,
      supportWhatsappNumber: null,
      setPartnerInfo: (info) => {
        set({
          sessionExpiredRedirectUrl: info.sessionExpiredRedirectUrl || null,
          partnerName: info.name || null,
          supportEmail: info.supportEmail || null,
          supportWhatsappNumber: info.supportWhatsappNumber || null,
        });
      },
      clearPartnerInfo: () => {
        set({
          sessionExpiredRedirectUrl: null,
          partnerName: null,
          supportEmail: null,
          supportWhatsappNumber: null,
        });
      },
    }),
    {
      name: "raas-widgets-flow-payout-claim-partner",
    }
  )
);

export const useCallbackUrl = (): string | null =>
  usePartnerStore((s) => s.sessionExpiredRedirectUrl);
